import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'
import BarChart from './BarChart'
// import ContribView from './ContribView'
import ScatterContainer from './ScatterContainer'
// import { PatternContainer } from '../data-patterns'
import TrendContainer from './TrendContainer'
import ContribContainer from './ContribContaier.js'
// import { WeeklyLostOppRevenue } from './WeekHourHeatmap'
// import PnlWeekly from './PnlWeekly'
import { connect } from 'react-redux'
// import GoalView from './GoalView'
import TimeSeriesForecast from './TimeSeriesForecast'
import { foreCastMetrics } from '../utils'
// import R from 'ramda'
// import BillDiff from '../bill-diff'
import { getPermitActions, getEnvConfig } from 'core/selectors'
import * as ScreenPermissions from 'core/EventActions'
// import { hours, count, rating, mw, dollars  } from '../constants'
import { getKpiSpec /* getContribKeys, getCAContribKeys */ } from '../selectors'
import { hasAccesPermits } from 'core/utils'
const BarChartRoutes = ({ kpiSpec, actionPermits, envConfig /* contribKeys, caContribKeys */ }) => {
  // const displayMap = R.compose(
  //   R.fromPairs,
  //   R.map(({ id, display }) => [id, display]),
  //   R.chain(({ metrics }) => metrics)
  // )(kpiSpec)

  const { authGodMode } = envConfig

  const hasGraphAccess = useMemo(
    _ =>
      authGodMode ||
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.GRAPH_MW,
          ScreenPermissions.GRAPH_COMMERCIAL,
          ScreenPermissions.GRAPH_FORECAST,
        ],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const hasGraphForecastsAccess = useMemo(
    _ =>
      authGodMode ||
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.GRAPH_MW,
          ScreenPermissions.GRAPH_COMMERCIAL,
          ScreenPermissions.GRAPH_FORECAST,
        ],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const hasGraphMWAndCommercialAccess = useMemo(
    _ =>
      authGodMode ||
      hasAccesPermits({
        authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.GRAPH_MW, ScreenPermissions.GRAPH_COMMERCIAL],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  if (!hasGraphAccess) return <></>

  return (
    <div>
      {// <Route exact path="/outage-hours" component={OutageHours}/>
      // <Route exact path="/outage-occurance" component={OutageOccurance}/>
      // <Route exact path="/mw-analysis" component={MwAnalysis}/>
      // <Route exact path="/dollars-analysis" component={Dollars}/>
      kpiSpec.map(({ id, metrics }) => {
        const Comp = () => <BarChart key={`${id}-content`} keys={metrics} />
        //
        return hasGraphMWAndCommercialAccess ? (
          <Route key={'bar/' + id} exact path={`/bar/${id}`} component={Comp} />
        ) : (
          <React.Fragment />
        )
      })}
      {/* <Route exact path="/goal" component={GoalView} /> */}

      {/* <Route exact path="/heatmaps/weekly-lost-opp-revenue" component={WeeklyLostOppRevenue} />

      <Route exact path="/heatmaps/pnl-weekly" component={PnlWeekly} /> */}
      {hasGraphMWAndCommercialAccess && <Route path="/scatter" component={ScatterContainer} />}
      {hasGraphMWAndCommercialAccess && <Route path="/contrib" component={ContribContainer} />}

      {hasGraphMWAndCommercialAccess && <Route path="/trend" component={TrendContainer} />}
      {/* <Route path="/pattern-analysis" component={PatternContainer} />
      <Route path="/bill-diff" component={BillDiff} /> */}

      {foreCastMetrics.map(({ display, id }) =>
        hasGraphForecastsAccess ? (
          <Route
            exact
            key={id}
            path={`/time-series-foecast/${id}`}
            render={() => <TimeSeriesForecast metricName={display} />}
          />
        ) : (
          <React.Fragment />
        )
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  envConfig: getEnvConfig(state),
  kpiSpec: getKpiSpec(state),
  actionPermits: getPermitActions(state),
  //  contribKeys: getContribKeys(state),
  // caContribKeys: getCAContribKeys(state),
})

export default connect(mapStateToProps)(BarChartRoutes)
